<template>
  <div id="roomList" class="container mt-4">
    <b-card title="新しいルームを作成する">
      <b-form class="col" @submit.prevent="onCreateRoom">
        <b-form-group label="ルーム名" label-for="pageInput">
          <b-form-input
            type="text"
            id="pageInput"
            required
            v-model="createRoomForm.name"
            placeholder="好きなルーム名"
          ></b-form-input>
        </b-form-group>

        <b-card v-if="isNotHaveGame" class="mb-2" title="新しいゲームを作成する">
          <b-form-group label="ゲームタイトル" label-for="pageInput">
            <b-form-input
              type="text"
              id="pageInput"
              v-model="createGameForm.title"
              placeholder="好きなゲーム名"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group label="説明" label-for="desInput">
            <b-form-input
              type="text"
              id="desInput"
              v-model="createGameForm.description"
              placeholder
            ></b-form-input>
          </b-form-group>
        </b-card>

        <b-form-group v-if="!isNotHaveGame" label="ゲームの選択" label-for="gameInput">
          <b-form-select
            id="gameInput"
            v-model="createRoomForm.gameId"
            required
            :options="getSelectOption"
          ></b-form-select>
        </b-form-group>

        <b-form-group label="管理者のプレイヤー名" label-for="playerName">
          <b-form-input
            type="text"
            id="playerName"
            v-model="createRoomForm.playerName"
            placeholder
            required
          ></b-form-input>
        </b-form-group>

        <div class="d-flex flex-row-reverse">
          <b-button variant="primary" class="mr-1" type="submit">作成</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import {
  createRoom,
  createGuest,
  createRequest,
  createGame
} from "../graphql/mutations.js";

import UserStore from "../store/index.js";
import { graphqlQuery } from "../util/queryUtil";
import { listGames } from "../graphql/queries.js";

export default {
  data() {
    return {
      createRoomForm: {
        name: "",
        gameId: "",
        playerName: ""
      },
      createGameForm: { title: "", description: "" },
      gameList: []
    };
  },
  methods: {
    onCreateRoom() {
      if (
        this.createRoomForm.name === "" ||
        this.createRoomForm.playerName === ""
      ) {
        return;
      }
      if (this.gameList.length === 0) {
        if (this.createGameForm.title === "") {
          return;
        }
        graphqlQuery(
          this,
          createGame,
          {
            input: Object.assign({}, this.createGameForm, {
              cards: [],
              characters: [],
              fieldTags: ["犯行現場", "庭"]
            })
          },
          result => {
            this.createRoomForm.gameId = result.data.createGame.id;
            this.createGameQuery();
          }
        );
      } else {
        this.createGameQuery();
      }
    },
    createGameQuery() {
      graphqlQuery(
        this,
        createRoom,
        {
          input: {
            name: this.createRoomForm.name,
            gameId: this.createRoomForm.gameId,
            gameTitle: "",
            gameDescription: "",
            fieldTags: ["庭", "犯行現場"],
            isCopiedGame: false,
            groups: [
              { id: this.getUniqueStr(), members: [] },
              { id: this.getUniqueStr(), members: [] },
              { id: this.getUniqueStr(), members: [] }
            ],
            characters: [],
            cards: [],
            // owner: UserStore.state.user.username
            editors: []
          }
        },
        this.onCreateFinished
      );
    },
    // 部屋を作ったあと
    onCreateFinished(result) {
      console.log("roomlist createRoom! ", result);

      // ゲストで自分を登録
      graphqlQuery(
        this,
        createGuest,
        {
          input: {
            roomId: result.data.createRoom.id,
            name: this.createRoomForm.playerName,
            userName: UserStore.state.user.username
          }
        },
        result_ => {
          // requestも作成
          graphqlQuery(
            this,
            createRequest,
            {
              input: {
                roomId: result_.data.createGuest.roomId,
                name: result_.data.createGuest.name,
                userName: result_.data.createGuest.userName,
                isAccept: true
              }
            },
            () => {
              this.$router.push("/room/" + result_.data.createGuest.roomId);
              console.log(result_);
            }
          );
        }
      );
    },

    getUniqueStr(myStrong) {
      var strong = 1000;
      if (myStrong) strong = myStrong;
      return (
        new Date().getTime().toString(16) +
        Math.floor(strong * Math.random()).toString(16)
      );
    },
    // ゲーム一覧を作る
    createGameList() {
      graphqlQuery(this, listGames, { limit: 100 }, result => {
        // console.log(result);
        this.gameList = result.data.listGames.items;
      });
    }
  },
  computed: {
    getSelectOption() {
      return this.gameList.map(game => {
        return { value: game.id, text: game.title };
      });
    },

    isNotHaveGame() {
      return this.gameList.length === 0;
    }
  },
  mounted() {
    this.createGameList();
  }
};
</script>
